import { z } from 'zod';

/**
 * A request the conversational agent has made to a human operator (admin) via the
 * `askAdmin` tool. The agent pauses generation until the admin answers (via
 * `answerAdminRequest`), at which point the answer is saved into the agent thread
 * as a tool-result and generation resumes. Answered rows are kept as history.
 */
export const adminRequestSchema = z.object({
  /** Agent thread this request belongs to. */
  threadId: z.string(),
  /** ai-sdk tool-call id; used to attach the answer back to the same tool call when resuming generation. */
  toolCallId: z.string(),
  /** Agent thread message that prompted the request; reused as the resume point. */
  promptMessageId: z.string(),
  /** The exact question the agent asked. */
  question: z.string(),
  /** Operator's answer. Null until answered. */
  answer: z.string().nullable().default(null),
  askedAt: z.number(),
  /** Set when the admin submits an answer; null while pending. */
  answeredAt: z.number().nullable().default(null),

  _creationTime: z.number().optional(),
  _id: z.string().optional(),
});
export type AdminRequest = z.output<typeof adminRequestSchema>;

export const adminRequestCvxSchema = adminRequestSchema.safeExtend({
  _creationTime: z.number(),
  _id: z.string(),
});
export type AdminRequestCvx = z.output<typeof adminRequestCvxSchema>;
